<template>
    <div>
        <div class="flex space-between mb15">
            <div class="flex1 mr100 flex aic jcc">
                <p class="flex0">常用方名称：</p>
                <el-input class="flex1 mr30" size="small" v-model="usedName" maxlength="20" show-word-limit
                          placeholder="请输入常用方名称" clearable></el-input>
                <p class="flex0">常用方拼音码：</p>
                <el-input class="flex1" size="small" v-model="usedCode" maxlength="20" show-word-limit
                          placeholder="请输入大写的拼音码（不输入会自动生成）" clearable></el-input>
                <p v-if="!isWest" class="flex0 ml30">
                    <span class="info-label">类型：</span>
                    <el-select v-model="dosageForm" placeholder="请选择" size="mini" class="width30">
                        <el-option
                                v-for="item in typeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                :disabled="item.disabled">
                        </el-option>
                    </el-select>
                </p>
            </div>
            <el-button type="primary" size="mini" class="flex0" @click="save">保存</el-button>
        </div>
        <div>
            <el-table :data="usedOrderInfoList"
                      :max-height="clientHeight*0.85"
                      border
                      style="width: 100%">
                <el-table-column type="index" min-width="40" align="center"></el-table-column>
                <el-table-column prop="drugName" label="药品名称、规格" min-width="250" align="center">
                    <template slot-scope="scope">
                        <el-autocomplete
                                size="small"
                                v-model="scope.row.drugName"
                                :fetch-suggestions="fetchMedicine"
                                @select="(selectItem) => { handleSelect(selectItem, scope.$index)}"
                        ></el-autocomplete>
                    </template>
                </el-table-column>
                <el-table-column prop="perMount" :label="type=='CHINESE_RECIPE'?'单次剂量':'单次药量'" min-width="100"
                                 align="center">
                    <template slot-scope="scope">
                        <el-input size="mini" v-model="scope.row.dosage" type="number" min="1"></el-input>
                    </template>
                </el-table-column>
                <el-table-column v-if="!isWest" prop="dosageUnit" label="单位" min-width="100" align="center"></el-table-column>
                <el-table-column prop="drugUnit" label="单位" min-width="100" align="center" v-else></el-table-column>
                <el-table-column v-if="!isWest" prop="admission" label="用法" min-width="150" align="center">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.admission" placeholder="请选择">
                            <el-option
                                    v-for="item in drugAdmissionList"
                                    :key="item.id"
                                    :label="item.dictKey"
                                    :value="item.dictKey">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>

                <el-table-column v-else prop="drugAdmission" label="用药途径" min-width="100">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.admission">
                            <el-option
                                    v-for="item in drugAdmissionList"
                                    :key="item.id"
                                    :label="item.dictValue"
                                    :value="item.dictValue">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column v-if="isWest" prop="frequencyCode" label="用药频率" min-width="100">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.frequencyObj">
                            <el-option
                                    v-for="item in drugFrequencyList"
                                    :key="item.id"
                                    :label="item.dictKey"
                                    :value="item.dictKey+'/'+item.dictValue">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column v-if="isWest" prop="date" label="用药天数" min-width="70">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.useDays"></el-input>
                    </template>
                </el-table-column>
                <el-table-column v-if="isWest" prop="dosageUnit" label="剂量单位" min-width="70"></el-table-column>
                <el-table-column v-if="isWest" prop="amount" label="开药量" min-width="70">
                    <template slot-scope="scope">
                        <el-input size="mini" v-model="scope.row.amount"></el-input>
                    </template>
                </el-table-column>

<!--                <el-table-column prop="drugOrigin" label="产地" min-width="100" align="center"></el-table-column>-->

                <el-table-column fixed="right" label="操作" align="center">
                    <template slot-scope="scope">
                          <span class="color_red fs18 pointer"
                                v-if="scope.$index>0||usedOrderInfoList.length>1"
                                @click="medicineDelete(scope.$index, scope.row)">x</span>
                    </template>
                </el-table-column>

            </el-table>
            <div class="mt10 mb10" @click="medicineAdd" style="cursor:pointer">
                <i class="el-icon-circle-plus"></i> 加行
            </div>
        </div>
    </div>
</template>

<script>
  import {tokenCache} from "../../lib/cache/Token";
  import {isEmpty} from "../../lib/utils";
  import vPinyin from '../../../src/lib/pinyin'

  export default {
    name: "used-detail",
    data() {
      return {
        typeOptions: [{value: '选项1', label: '饮片'}], //中药有两种类型 饮片或者颗粒
        usedOrderInfoList: [{}],
        drugAdmissionList: [], //用法列表
        drugFrequencyList: [],//频次
        usedName: '',
        usedCode: '',
        orderType: this.$route.query.type,
        usedType: this.$route.query.type === 'CHINESE_RECIPE' ? 'CHINESE_USED':'WESTERN_USED',
        dosageForm: '饮片'
      }
    },
    computed: {
      clientHeight() {
        return (document.documentElement.clientHeight - 1 || document.body.clientHeight - 1) - 110
      },
      type() {
        return this.$route.query.type
      },
      //是否是西药
      isWest() {
          return this.$route.query.type === 'WESTERN_RECIPE'
      }
    },
    created() {
      if (this.$route.query.id) {
        let list = this.$cache.get('usedOrderInfo')
        this.usedOrderInfoList = list.usedOrderInfoList
          console.log(1212, this.usedOrderInfoList, 3434, list.usedOrderInfoList)
        this.usedName = list.usedName
        this.usedCode = list.usedCode
      }
      this.getMedicineParams()
    },
    methods: {
      save() {
        let check = this.usedOrderInfoList.filter((item) => {
          return item.drugName
        })
        if (check.length === 0) {
          return this.$alert('您当前的处方页内没有数据，请先维护药品数据然后再添加至常用方', '提示', {
            confirmButtonText: '确定',
          });
        }

        let empty = this.usedOrderInfoList.filter((item) => {
          return !item.drugName
        })
        if (empty.length > 0) {
          return this.$confirm('您所提交的处方中有一处空白，请完善处方或删除后再次提交。', '请注意', {
            confirmButtonText: '确定',
            type: 'warning',
            showCancelButton: false
          }).catch(() => {
          })
        }

        let error = false
        if(this.type==='CHINESE_RECIPE'){
          this.usedOrderInfoList.forEach((d) => {
            if (isEmpty(d.dosage)) {
              this.$message.error('请选择单次剂量')
              error = true
            }
          })
        }else{
          this.usedOrderInfoList.forEach((d) => {
            if (isEmpty(d.dosage)) {
              this.$message.error('请选择单次药量')
              error = true
            }else if (isEmpty(d.admission)) {
              this.$message.error('请选择用药途径')
              error = true
            }else if (isEmpty(d.frequencyObj)) {
              this.$message.error('请选择用药频率')
              error = true
            }else if (isEmpty(d.useDays)) {
              this.$message.error('请选择用药天数')
              error = true
            }else if (isEmpty(d.amount)) {
              this.$message.error('请选择开药量')
              error = true
            }else{
              d.frequencyCode = d.frequencyObj.indexOf('/')>-1? d.frequencyObj.split('/')[0] : d.frequencyCode
              d.frequencyName = d.frequencyObj.indexOf('/')>-1? d.frequencyObj.split('/')[1] : d.frequencyName
            }
          })
        }
        if (error) return

        if (!this.usedName) {
          this.$confirm(`请给本套常用方起一个名字`, '提示', {
            confirmButtonText: '确定',
            showCancelButton: true,
            type: 'warning'
          }).then(() => {
            return false
          })
        } else {
          if (this.$route.query.id) {
            this.insertUsed()
          } else {
            this.checkUsedName()
          }
        }
      },
      //常用方名称检验
      async checkUsedName() {
        const {code, obj} = await this.$http("smarthos.recipe.usedorder.usedname.verify", {
            usedType: this.usedType,
            usedName: this.usedName, //常用方名称
            id: this.$route.query.id //常用方id
          }, 'post',
          true,
          false)
        if (code == '0') {
          this.insertUsed()
        } else {
          this.$message.error('已存在该常用方名称')
        }
      },
      //常用方保存
      async insertUsed() {
        let {query: {id}} = this.$route
        let url = id ? 'smarthos.recipe.usedorder.modify' : 'smarthos.recipe.usedorder.insert'
        const {code, obj, msg} = await this.$http(url, {
          usedType: this.usedType,
          usedName: this.usedName,
          usedCode: this.usedCode,
          usedOrderInfoList: this.usedOrderInfoList,
          dosageForm: this.dosageForm,
          id: id
        });
        if (code == '0') {
          let tip = id ? '修改' : '保存'
          this.$alert(`您的常用方“<span class="color_main">${this.usedName}</span>”${tip}成功，如需修改请在“常用方管理”功能内进行修改`, `常用方${tip}成功`, {
            confirmButtonText: '确定',
            dangerouslyUseHTMLString: true,
          }).then(() => {
            this.$router.back()
          });
        }
      },

      async getMedicineParams() {
        const {obj} = await this.$http('smarthos.system.dict.drug.list', {})
        this.drugAdmissionList = this.isWest ? obj.westernDrugAdmissionList : obj.drugAdmissionList
        for (let i of obj.drugFrequencyList) {
          i.frequencyObj = i.dictKey + '/' + i.dictValue
        }
        this.drugFrequencyList = obj.drugFrequencyList
      },
      async fetchMedicine(queryString, cb) {
        let {code, list} = await this.$http("smarthos.recipe.drug.list.page", {
          orderType: this.orderType,
          dosageForm: this.orderType === 'CHINESE_RECIPE' ? '饮片' : null,
          keyword: queryString,
          token: tokenCache.get(),
        })
        if (code === '0') {
          list.forEach((item) => {
            item.id && (item.drugId = item.id)
            // item.value = `${item.drugName} ` + ` ${item.price / 100}元/${item.drugUnit} ` + ` ${item.drugOrigin}`; //必须绑定value值作为显示数据
            item.value = `${item.drugName} ` ; //必须绑定value值作为显示数据
          })
          cb(list);
        }
      },
      //选择药品
      handleSelect(item, index) {
        let usedOrderInfoList = this.usedOrderInfoList
        let idList = []
        usedOrderInfoList.forEach((item) => {
          idList.push(item.drugId)
        })
        if (usedOrderInfoList.length > 0) {
          if (!usedOrderInfoList.includes(item) && idList.indexOf(item.drugId) < 0) {
            this.usedOrderInfoList[index] = item
          } else {
            this.usedOrderInfoList.pop()
            return this.$message.error('请勿重复添加药品')
          }
        } else {
          this.usedOrderInfoList[index] = item
        }
      },
      medicineDelete(i) {
        this.usedOrderInfoList.splice(i, 1)
      },
      medicineAdd() {
        this.usedOrderInfoList.push({})
      },
    },
    watch: {
      usedName: {
        handler(newV) {
          this.usedCode = vPinyin.chineseToPinYin(newV)
        }
      }
    }
  }
</script>

<style scoped lang="scss">

</style>
